<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter1"><b>GRANDMA’S SONG</b> </p>
<p class="textcenterwithspace1">When Grandma cries</p>
<p class="textcenter">Tears fall like bombs</p>
<p class="textcenter">Exploding in my ears.</p>
<p class="textcenterwithspace1">Her heartbeat slows</p>
<p class="textcenter">The drum strikes low</p>
<p class="textcenter">Pounding out hard years,</p>
<p class="textcenterwithspace1">Yet in the sadness</p>
<p class="textcenter">The pulse of gladness</p>
<p class="textcenter">The path to wisdom true.</p>
<p class="textcenterwithspace1">When Grandma cries</p>
<p class="textcenter">Tears fall like rain</p>
<p class="textcenter">And life, it springs anew.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// illu_a.vue?18ce75da